import { render } from "./BoxOfStatics.vue?vue&type=template&id=304cf6c8&scoped=true"
import script from "./BoxOfStatics.vue?vue&type=script&lang=js"
export * from "./BoxOfStatics.vue?vue&type=script&lang=js"

import "./BoxOfStatics.vue?vue&type=style&index=0&id=304cf6c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304cf6c8"]])

export default __exports__